<template>
  <path
    d="M21 5.00018V11.5902L18.71 9.29018C18.32 8.90018 17.68 8.90018 17.29 9.29018L14 12.5902L10.71 9.30018C10.32 8.91018 9.69 8.91018 9.3 9.30018L6 12.5902L3 9.58018V5.00018C3 3.90018 3.9 3.00018 5 3.00018H19C20.1 3.00018 21 3.90018 21 5.00018ZM18 11.4202L21 14.4302V19.0002C21 20.1002 20.1 21.0002 19 21.0002H5C3.9 21.0002 3 20.1002 3 19.0002V12.4202L5.29 14.7102C5.68 15.1002 6.31 15.1002 6.7 14.7102L10 11.4102L13.29 14.7002C13.68 15.0902 14.31 15.0902 14.7 14.7002L18 11.4202Z"
  />
</template>
